<template>
  <div class="blog">
    <div class="container background-container">
      <div class="blog__banner-fade" />
      <div
        class="blog__banner"
        :style="{
          backgroundImage: bgImage
        }"
      />
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="semi-bold mb-4">Latest News / Blog</h2>
        </div>
      </div>

      <div class="row">
        <div
          v-for="creator in itemsToShow"
          :key="creator.link"
          class="col-md-3 mb-5"
          @click="handleBlogClick(creator.link)"
        >
          <div class="blog__item">
            <img
              :src="getCreatorImage(creator.image)"
              alt="post"
              class="w-100"
            />
            <p class="blog__item-title">
              {{ creator.title }}
            </p>
            <NuxtLink class="blog__item-more" :to="localePath(creator.link)">
              Read more
              <img
                class="ml-2"
                src="@/assets/icons/arrows/right-primary.svg"
                alt="right"
              />
            </NuxtLink>
          </div>
        </div>
      </div>

      <div v-if="visibleItemsCount < filteredItems.length" class="row">
        <div class="col-md-12">
          <div class="text-center pb-5 pt-3 w-100">
            <Button variant="outline" size="sm" @click="handleShowMoreClick">
              View more
            </Button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import take from 'lodash/take';
import creators from './creators';
import Button from '@/components/Elements/Button.vue';
import Tag from '@/components/Elements/Tag.vue';

const CREATOR_TOPIC_1 = 'General';
const CREATOR_TOPIC_2 = 'Creator Stories';

export default {
  name: 'BlogPage',
  components: { Tag, Button },

  data() {
    return {
      creators,
      visibleItemsCount: 8,
      bgImage: null,
      activeFilter: 'All',
      tags: [CREATOR_TOPIC_1, CREATOR_TOPIC_2]
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    filteredItems() {
      if (this.activeFilter !== 'All') {
        return creators.filter(
          (creator) => creator.topic === this.activeFilter
        );
      }
      return creators;
    },
    itemsToShow() {
      return take(this.filteredItems, this.visibleItemsCount);
    }
  },

  mounted() {
    this.bgImage = `url(${require(`@/assets/blog/blog-banner.png`)})`;

    this.activeFilter = this.$route.query?.filter
      ? this.$route.query?.filter
      : 'All';
  },

  methods: {
    handleShowMoreClick() {
      if (this.visibleItemsCount <= this.filteredItems.length) {
        this.visibleItemsCount = this.visibleItemsCount + 4;
      }
    },
    onTagClick(tag) {
      this.activeFilter = tag;
      this.$router.replace('/blog?filter=' + tag);
    },
    getCreatorImage(image) {
      return require(`@/assets/images/blog/${image}`);
    },
    handleBlogClick(link) {
      this.$router.push(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  .background-container {
    position: relative;
    height: 550px;

    @media (min-width: $screen-width-lg) {
      background-size: 100% auto;
      height: 500px;
    }
  }
  .blog__banner-fade {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #000517 0%, #fff 35%), #000517;
    mix-blend-mode: multiply;
  }
  &__banner {
    margin-top: 35px;
    background-size: auto 110%;
    background-repeat: no-repeat;
    background-position: top center;
    height: 550px;

    @media (min-width: $screen-width-lg) {
      background-size: 100% auto;
      height: 500px;
    }

    @media (min-width: $screen-width-md) {
      background-position: bottom center;
    }
  }

  &__item {
    cursor: pointer;
  }

  &__item-title {
    font-size: 18px;
    font-family: 'Poppins-SemiBold', sans-serif;
    margin-top: 25px;
    min-height: 81px;
  }

  &__item-more {
    color: $primary-color;

    &:hover {
      text-decoration: none;
    }
  }
}

.semi-bold {
  font-family: 'Poppins-SemiBold', sans-serif;
}
</style>
